import localforage from 'localforage';
import type { Action, Reducer } from 'redux';
import { persistReducer as persist, purgeStoredState } from 'redux-persist';
import type { PersistConfig, PersistState } from 'redux-persist';

declare module 'redux-persist' {
  export function persistReducer<S, A extends Action = Action, P = S>(
    config: PersistConfig<S>,
    baseReducer: Reducer<S, A, P>,
  ): Reducer<
    S & { _persist: PersistState },
    A,
    P & { _persist?: PersistState }
  >;
}

const config = {
  storage: localforage,
  keyPrefix: 'slab',
};
const keys: string[] = [];

export function purgePersisted() {
  keys.forEach((key) => {
    purgeStoredState({
      ...config,
      key,
    });
  });
}

export function persistReducer<S, A extends Action = Action, P = S>(
  options: {
    key: string;
    whitelist: (keyof S)[];
    migrate?: (state: S, currentVersion: number) => Promise<S>;
  },
  reducer: Reducer<S, A>,
): Reducer<S & { _persist: PersistState }, A, P & { _persist?: PersistState }> {
  keys.push(options.key);
  return persist<S, A, P>(
    {
      ...config,
      ...options,
      whitelist: options.whitelist as string[],
      // @ts-expect-error
      migrate: options.migrate,
    },
    reducer,
  );
}
